import { cn } from '~/lib/utils';
import figma1 from '~/landing_page/Assets/figma1.png';
import figma2 from '~/landing_page/Assets/figma2.png';
import figma3 from '~/landing_page/Assets/figma3.png';
import figmaIcon from '~/landing_page/Assets/Figma.png';
import styles from './WidgetCard.module.css';

export interface FigmaArtboardsCardProps {
  className?: string;
  title?: string;
  artboards?: string[];
}

export const FigmaArtboardsCard = ({
  className,
  title = 'Auth flow redesign',
  artboards = [figma1, figma2, figma3],
}: FigmaArtboardsCardProps) => {
  return (
    <div className={cn(styles.card, className)}>
      <div className={styles.row}>
        <img src={figmaIcon} className={styles.icon} alt="Figma" />
        <div className={styles.body}>
          <p className={styles.title}>{title}</p>
          <div className={styles.artboardsGrid}>
            {artboards.map((src, i) => (
              <div key={i} className={styles.artboard}>
                <img src={src} alt="" className={styles.artboardImage} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

FigmaArtboardsCard.displayName = 'FigmaArtboardsCard';
